import axios from 'axios';
import { useMessage } from '@/utils/confirm';
import useLoading from '@/utils/loading';
import store from '../store';
import router from '../router';

// create an axios instance
const service = axios.create({
  baseURL: process.env.baseUrl, //process.env.publicPath
  timeout: 25000, // request timeout
  loading: true, //要不要顯示loading動畫
  headers: {
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache,no-store',
  },
});

service.interceptors.request.use(
  (config) => {
    if (config.loading) useLoading(true);
    if (store.getters['system/getSession'] || sessionStorage.getItem('session')) {
      config.headers['session'] = store.getters['system/getSession'] || sessionStorage.getItem('session');
    }
    return config;
  },
  (error) => {
    useLoading(false);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    if (response.config.url !== '/api/posclient/echo' && response.config.loading) {
      useLoading(false);
    }
    if (!response.data.error) {
      return response.data;
    } else {
      console.log(response.data.error);
      // session not found、登入資訊錯誤、登入班別已清帳，需強制登出
      if (response.data.error.code === '10006' || response.data.error.code === '10039') {
        useMessage('錯誤提示', `${response.data.error.message}`, { confirmText: '登出', hideClose: true })
          .then(() => {
            store.dispatch('system/doLogout');
          })
          .catch((e) => e);
      } else if (
        // 給PosClient用的，訊息不要POP出來
        response.data.error.code !== '11000' &&
        // 取消掃描的終止讀取回覆，此 error 不顯示
        response.data.error.code !== '40101' &&
        // timeout 的回覆，此 error 不顯示
        response.data.error.code !== '40007' &&
        // 訂單已經結帳的回覆，此 error 不顯示並另外處理
        response.data.error.code !== '30101' &&
        router.currentRoute.value.path !== '/guest'
      ) {
        useMessage('錯誤提示', `${response.data.error.message}`).catch((e) => e);
      }
      return Promise.reject(response.data.error);
    }
  },
  (error) => {
    if (error.response?.config.url !== '/api/posclient/echo' && error.response?.config.loading) {
      useLoading(false);
    }
    //掃描504不顯示/客險畫面不顯示/軟體為更新狀態時(status = 4)不顯示
    if (
      !(error.response?.config.url === '/api/posclient/scan' && error.response?.status === 504) &&
      router.currentRoute.value.path !== '/guest' &&
      store.getters['upgrade/getSoftwareStatus'] !== 4
    ) {
      useMessage(
        '系統異常',
        `系統執行錯誤（錯誤代碼：${error.response?.status}）<br />如有疑問，請洽客服處理：04-8539998`
      ).catch((e) => e);
    }
    return Promise.reject(error);
  }
);

export default service;
